module.exports = __webpack_public_path__ + "img/1.4d24bb41.svg";